import { onExtractorSessionActivity } from "common/signalR";
import ListTemplate from "components/ListTemplate";
import React, { useEffect } from "react";
import { useLoaderData } from "react-router";
import { AIAssistantPanel } from "../AIAssistantPanel";
import { cardLayout } from "./cardLayout";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import confetti from "canvas-confetti";
import { useExtractorSessionCacheSync } from "./useExtractorSessionCacheSync";

const ExtractorSessionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ExtractorSessionListFrontModel>();

  useExtractorSessionCacheSync();

  useEffect(() => {
    const res = onExtractorSessionActivity(async activity => {
      if (activity.action.value !== "finishedProcessing") return;

      const response = await window.CoreApi.Extractor.GetExtractorSession(activity.itemId);
      if (response.data.data.lifeCycle === "waitingForUserAction") {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 }
        });
      }
    });

    return () => {
      res.removeEvent();
    }
  }, []);

  return <div className="flex-column panel-gap">
    <div className="flex panel-gap">
      <AIAssistantPanel />
    </div>
    <ListTemplate
      title="Data extraction sessions"
      filterSet="extractorSession_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Extractor.Paginated}
      getId={item => item.extractorSessionId}
      layout={cardLayout()}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </div>
};

export default ExtractorSessionListApp;
